import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Button } from 'rsuite'
import ClusterChart from './charts/ClusterChart'
import ProjectAllCharts from './charts/ProjectAllCharts'
import ProjectCharts from './charts/ProjectCharts'
import DashboradToggle from './DashboradToggle'

export default function ProjectCusterDashboard({
  isSetting,
  isShow,
  onSettingChange,
  dashboradName,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [type, setType] = useState('all')
  const [schema, setSchema] = useState()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    try {
      // const response = await getUserProfile()
      // setSchema(response)

      // mock schema
      const response = mock
      // if (response.filterProject.value) {
      setType('all')
      // } else {
      //   setType('project')
      // }
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {schema && (
        <Panel header="" bordered collapsible defaultExpanded shaded>
          <Row style={{ marginTop: 0 }}>
            {!isSetting && (
              <>
                {schema.filterAll && (
                  <Button
                    style={{
                      color: '#fff',
                      backgroundColor: schema.filterAll.bgColor,
                      fontWeight: 800,
                      marginLeft: 10,
                      minWidth: 120,
                    }}
                    disabled={isLoading}
                    onClick={() => {
                      setType('all')
                    }}
                  >
                    {schema.filterAll.label}
                  </Button>
                )}

                {schema.filterProject && (
                  <Button
                    style={{
                      color: '#fff',
                      backgroundColor: schema.filterProject.bgColor,
                      fontWeight: 800,
                      marginLeft: 10,
                      minWidth: 120,
                    }}
                    disabled={isLoading}
                    onClick={() => {
                      setType('project')
                    }}
                  >
                    {schema.filterProject.label}
                  </Button>
                )}
              </>
            )}
          </Row>

          {(type == 'all' || isSetting) && (
            <Row style={{ marginTop: 10 }}>
              {isSetting && (
                <div>
                  <b>{schema.filterAll.label}</b>
                </div>
              )}
              {schema.dataAll?.map((item) => (
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div style={{ marginRight: 10 }}>
                    {isSetting && (
                      <DashboradToggle
                        onChange={onSettingChange}
                        dashboradName={dashboradName}
                        checked={isShow}
                      />
                    )}
                    <ProjectAllCharts schema={item} />
                  </div>
                </Col>
              ))}
            </Row>
          )}
          {(type == 'project' || isSetting) && (
            <Row style={{ marginTop: 10 }}>
              {isSetting && (
                <div style={{ marginTop: 10 }}>
                  <b>{schema.filterProject.label}</b>
                </div>
              )}
              <ProjectCharts
                schema={schema.dataProject}
                isSetting={isSetting}
                isShow={isShow}
                onSettingChange={onSettingChange}
                dashboradName={dashboradName}
              />
            </Row>
          )}
        </Panel>
      )}
    </>
  )
}

const mock = {
  filterProject: {
    bgColor: '#d87a80',
    label: 'โครงการ',
    value: false,
  },
  filterAll: {
    bgColor: '#5ab1ef',
    label: 'ทั้งหมด',
    value: true,
  },
  dataProject: {
    clusterList: [
      {
        name: 'Cluster 1',
        // value: 80,
        // color: '#d87a80',
        gaugeColor: ['#3ab294', '#ffb980'],
        disburse: {
          label: 'เบิกจ่าย',
          value: 738840,
          percent: 70,
        },
        approve: {
          label: 'อนุมัติ',
          value: 923550,
          percent: 80,
        },
      },
      {
        name: 'Cluster 2',
        // value: 80,
        // color: '#8d98b3',
        gaugeColor: ['#3ab294', '#ffb980'],
        disburse: {
          label: 'เบิกจ่าย',
          value: 738840,
          percent: 70,
        },
        approve: {
          label: 'อนุมัติ',
          value: 923550,
          percent: 80,
        },
      },
      {
        name: 'Cluster 3',
        // value: 80,
        // color: '#f6e187',
        gaugeColor: ['#3ab294', '#ffb980'],
        disburse: {
          label: 'เบิกจ่าย',
          value: 738840,
          percent: 70,
        },
        approve: {
          label: 'อนุมัติ',
          value: 923550,
          percent: 80,
        },
      },
      {
        name: 'Cluster 4',
        // value: 80,
        // color: '#5ab1ef',
        gaugeColor: ['#3ab294', '#ffb980'],
        disburse: {
          label: 'เบิกจ่าย',
          value: 738840,
          percent: 70,
        },
        approve: {
          label: 'อนุมัติ',
          value: 923550,
          percent: 80,
        },
      },
      // {
      //   name: 'Cluster 5',
      //   // value: 80,
      //   // color: '#b6a2de',
      //   gaugeColor: ['#3ab294', '#ffb980'],
      //   disburse: {
      //     label: 'เบิกจ่าย',
      //     value: 738840,
      //     percent: 70,
      //   },
      //   approve: {
      //     label: 'อนุมัติ',
      //     value: 923550,
      //     percent: 80,
      //   },
      // },
    ],

    details: [
      {
        name: 'Cluster 1',
        color: '#d87a80',
        processingLabel: 'จำนวนดำเนินการ',
        processing: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        delayedLabel: 'จำนวนล่าช้า',
        delayed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        closedLabel: 'จำนวนปิด',
        closed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        totalLabel: 'จำนวนทั้งหมด',
        total: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      {
        name: 'Cluster 2',
        color: '#8d98b3',
        processingLabel: 'จำนวนดำเนินการ',
        processing: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        delayedLabel: 'จำนวนล่าช้า',
        delayed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        closedLabel: 'จำนวนปิด',
        closed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        totalLabel: 'จำนวนทั้งหมด',
        total: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      {
        name: 'Cluster 3',
        color: '#f6e187',
        processingLabel: 'จำนวนดำเนินการ',
        processing: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        delayedLabel: 'จำนวนล่าช้า',
        delayed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        closedLabel: 'จำนวนปิด',
        closed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        totalLabel: 'จำนวนทั้งหมด',
        total: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      {
        name: 'Cluster 4',
        color: '#5ab1ef',
        processingLabel: 'จำนวนดำเนินการ',
        processing: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        delayedLabel: 'จำนวนล่าช้า',
        delayed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        closedLabel: 'จำนวนปิด',
        closed: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
        totalLabel: 'จำนวนทั้งหมด',
        total: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      // {
      //   name: 'Cluster 5',
      //   color: '#b6a2de',
      //   processingLabel: 'จำนวนดำเนินการ',
      //   processing: {
      //     label: '9999',
      //     value: 999999999,
      //     datas: [
      //       {
      //         label: 'อนุมัติ',
      //         value: '80',
      //         color: '#3ab294',
      //       },
      //       {
      //         label: 'เบิกจ่าย',
      //         value: '50',
      //         color: '#ffb980',
      //       },
      //     ],
      //   },
      //   delayedLabel: 'จำนวนล่าช้า',
      //   delayed: {
      //     label: '9999',
      //     value: 999999999,
      //     datas: [
      //       {
      //         label: 'อนุมัติ',
      //         value: '80',
      //         color: '#3ab294',
      //       },
      //       {
      //         label: 'เบิกจ่าย',
      //         value: '50',
      //         color: '#ffb980',
      //       },
      //     ],
      //   },
      //   closedLabel: 'จำนวนปิด',
      //   closed: {
      //     label: '9999',
      //     value: 999999999,
      //     datas: [
      //       {
      //         label: 'อนุมัติ',
      //         value: '80',
      //         color: '#3ab294',
      //       },
      //       {
      //         label: 'เบิกจ่าย',
      //         value: '50',
      //         color: '#ffb980',
      //       },
      //     ],
      //   },
      //   totalLabel: 'จำนวนทั้งหมด',
      //   total: {
      //     label: '9999',
      //     value: 999999999,
      //     datas: [
      //       {
      //         label: 'อนุมัติ',
      //         value: '80',
      //         color: '#3ab294',
      //       },
      //       {
      //         label: 'เบิกจ่าย',
      //         value: '50',
      //         color: '#ffb980',
      //       },
      //     ],
      //   },
      // },
    ],
  },
  dataAll: [
    {
      name: 'Cluster 1',
      // value: 80,
      color: '#d87a80',
      gaugeColor: ['#3ab294', '#ffb980'],
      disburse: {
        label: 'เบิกจ่าย',
        value: 738840,
        percent: 70,
      },
      approve: {
        label: 'อนุมัติ',
        value: 923550,
        percent: 80,
      },
      data1: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
        ],
      },
      data2: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
          {
            label: 'บริหารสำนัก',
            value: '30',
            color: '#5ab1ef',
          },
        ],
      },
    },
    {
      name: 'Cluster 2',
      // value: 75,
      color: '#8d98b3',
      gaugeColor: ['#3ab294', '#ffb980'],
      disburse: {
        label: 'เบิกจ่าย',
        value: 738840,
        percent: 70,
      },
      approve: {
        label: 'อนุมัติ',
        value: 923550,
        percent: 80,
      },
      data1: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
        ],
      },
      data2: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
          {
            label: 'บริหารสำนัก',
            value: '30',
            color: '#5ab1ef',
          },
        ],
      },
    },
    {
      name: 'Cluster 3',
      // value: 40,
      color: '#f6e187',
      gaugeColor: ['#3ab294', '#ffb980'],
      disburse: {
        label: 'เบิกจ่าย',
        value: 738840,
        percent: 70,
      },
      approve: {
        label: 'อนุมัติ',
        value: 923550,
        percent: 80,
      },
      data1: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
        ],
      },
      data2: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
          {
            label: 'บริหารสำนัก',
            value: '30',
            color: '#5ab1ef',
          },
        ],
      },
    },
    {
      name: 'Cluster 4',
      // value: 50,
      color: '#5ab1ef',
      gaugeColor: ['#3ab294', '#ffb980'],
      disburse: {
        label: 'เบิกจ่าย',
        value: 738840,
        percent: 70,
      },
      approve: {
        label: 'อนุมัติ',
        value: 923550,
        percent: 80,
      },
      data1: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
        ],
      },
      data2: {
        label: '9999',
        value: 999999999,
        datas: [
          {
            label: 'โครงการ',
            value: '80',
            color: '#ffb980',
          },
          {
            label: 'จัดซื้อจัดจ้าง',
            value: '50',
            color: '#f6e187',
          },
          {
            label: 'บริหารสำนัก',
            value: '30',
            color: '#5ab1ef',
          },
        ],
      },
    },
    // {
    //   name: 'Cluster 5',
    //   // value: 50,
    //   color: '#b6a2de',
    //   gaugeColor: ['#3ab294', '#ffb980'],
    //   disburse: {
    //     label: 'เบิกจ่าย',
    //     value: 738840,
    //     percent: 70,
    //   },
    //   approve: {
    //     label: 'อนุมัติ',
    //     value: 923550,
    //     percent: 80,
    //   },
    //   data1: {
    //     label: '9999',
    //     value: 999999999,
    //     datas: [
    //       {
    //         label: 'โครงการ',
    //         value: '80',
    //         color: '#ffb980',
    //       },
    //       {
    //         label: 'จัดซื้อจัดจ้าง',
    //         value: '50',
    //         color: '#f6e187',
    //       },
    //     ],
    //   },
    //   data2: {
    //     label: '9999',
    //     value: 999999999,
    //     datas: [
    //       {
    //         label: 'โครงการ',
    //         value: '80',
    //         color: '#ffb980',
    //       },
    //       {
    //         label: 'จัดซื้อจัดจ้าง',
    //         value: '50',
    //         color: '#f6e187',
    //       },
    //       {
    //         label: 'บริหารสำนัก',
    //         value: '30',
    //         color: '#5ab1ef',
    //       },
    //     ],
    //   },
    // },
  ],
}
